export const WHY_IT_ITEMS = [
  'Impact across the automotive sector',
  'Building modern service infrastructure',
  'Enabling market expansion in Iraq',
  'Improving customer ownership experience',
]
